<app-header></app-header>
<main class="main-content">
    <!------main-content------>
    <!-----------page_title--------------->
    <section class="page_title  pdt_80  pdb_40">
       <div class="container">
          <div class="row">
             <!---------row----------->
             <div class="col-lg-12 col-md-12 text-center">
                <!---------col----------->
                <div class="content_box">
                   <h6>Frequently Asked Questions </h6>
                   <h1> Happy to help you</h1>
                   <ul class="bread_crumb text-center">
                      <li class="bread_crumb-item"><a href="#">Home</a></li>
                      <li class="bread_crumb-item active"> Faqs </li>
                   </ul>
                </div>
                <!---------col-end---------->
             </div>
             <!----------row-end---------->
          </div>
       </div>
    </section>
    <!-----------page_title-end-------------->
    
    <!-----------faq--------------->
    <section class="faq type_two  pdt_100 pdb_100">
      <div class="container">
         <div class="row">
            <!---------row----------->
            <div class="col-lg-12 col-md-12">
               <!---------col----------->
               <div class="title">
                  <h1 class="text-center">Most common questions  </h1>
                  <p class="text-center"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
               </div>
               <!---------col-end---------->
            </div>
            <!----------row-end---------->
         </div>





         <div id="faqtypetwo">
            <div class="row">
               <div class="col-lg-6">
                  <!---------col----------->
                  <div class="card faqs_card_tptwo">
                     
                     
                     <div class="faq-header-bg" id="faqheaderone">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#faqone" aria-expanded="false" aria-controls="faqone">
                        <span class="linearicons-question"></span>  
                        What should I do if I come into contact with a person with COVID-19?
                        <small class="linearicons-chevron-down-circle"></small>
                        </button>
                     </div>


                     <div id="faqone" class="collapse" aria-labelledby="faqheaderone" data-parent="#faqtypetwo">
                        <div class="card-body font-13-line-24">
                           Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </div>
                     </div>
                  </div>
                  <div class="card faqs_card_tptwo">
                     <div class="faq-header-bg" id="faqheadertwo">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#faqtwo" aria-expanded="false" aria-controls="faqtwo">
                        <span class="linearicons-question"></span>  
                        What should I do if I come into contact with a person with COVID-19?
                        <small class="linearicons-chevron-down-circle"></small>
                        </button>
                     </div>
                     <div id="faqtwo" class="collapse" aria-labelledby="faqheadertwo" data-parent="#faqtypetwo">
                        <div class="card-body font-13-line-24">
                           Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.   
                        </div>
                     </div>
                  </div>
                  <div class="card faqs_card_tptwo">
                     <div class="faq-header-bg" id="faqheaderthree">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#faqthree" aria-expanded="false" aria-controls="faqthree">
                        <span class="linearicons-question"></span>  
                        What should I do if I come into contact with a person with COVID-19?
                        <small class="linearicons-chevron-down-circle"></small>
                        </button>
                     </div>
                     <div id="faqthree" class="collapse" aria-labelledby="faqheaderthree" data-parent="#faqtypetwo">
                        <div class="card-body font-13-line-24">
                           Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </div>
                     </div>
                  </div>
                  <!---------col-end---------->
               </div>
               <div class="col-lg-6">
                  <!---------col----------->
                  <div class="card faqs_card_tptwo">
                     <div class="faq-header-bg" id="faqheaderfour">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#faqfour" aria-expanded="false" aria-controls="faqfour">
                        <span class="linearicons-question"></span>  
                        What should I do if I come into contact with a person with COVID-19?
                        <small class="linearicons-chevron-down-circle"></small>
                        </button>
                     </div>
                     <div id="faqfour" class="collapse" aria-labelledby="faqheaderfour" data-parent="#faqtypetwo">
                        <div class="card-body font-13-line-24">
                           Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </div>
                     </div>
                  </div>
                  <div class="card faqs_card_tptwo">
                     <div class="faq-header-bg collapsed" id="faqheaderfive">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#faqfive" aria-expanded="false" aria-controls="faqfive">
                        <span class="linearicons-question"></span>  
                        What should I do if I come into contact with a person with COVID-19?
                        <small class="linearicons-chevron-down-circle"></small>
                        </button>
                     </div>
                     <div id="faqfive" class="collapse" aria-labelledby="faqheaderfive" data-parent="#faqtypetwo">
                        <div class="card-body font-13-line-24">
                           Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </div>
                     </div>
                  </div>
                  <div class="card faqs_card_tptwo">
                     <div class="faq-header-bg" id="faqheadersix">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#faqsix" aria-expanded="false" aria-controls="faqsix">
                        <span class="linearicons-question"></span>  
                        What should I do if I come into contact with a person with COVID-19?
                        <small class="linearicons-chevron-down-circle"></small>
                        </button>
                     </div>
                     <div id="faqsix" class="collapse" aria-labelledby="faqheadersix" data-parent="#faqtypetwo">
                        <div class="card-body font-13-line-24">
                           Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </div>
                     </div>
                  </div>
                  <!---------col-end---------->
               </div>
               <!----------row-end---------->
            </div>
         </div>
      </div>
   </section>
 <app-footer></app-footer>
   
 </main>

<app-scrolltotop></app-scrolltotop>
<app-whatsupchat></app-whatsupchat>

 